// Turning a stored crop into the two CSS properties that actually move a photograph in its frame.
//
// Kept as CSS rather than redrawn onto a canvas because the adjustment is a view, not an edit: the
// uploaded bytes are never touched, so a crop can be changed or undone years later, and the same
// stored value renders correctly in the square strip, the 4:3 cover and the gallery tile without
// any of them knowing about the others.

import type { CSSProperties } from 'react';
import { isDefaultCrop, type PhotoCrop } from '../api/entry-photos';

/**
 * `object-position` moves the picture inside the frame; `transform: scale` pushes further in, with
 * its origin pinned to the same point so zooming closes in on what the writer chose rather than
 * drifting away from it. The frame's own `overflow: hidden` does the cropping.
 *
 * An unadjusted photo returns nothing at all, so it keeps rendering by the stylesheet alone.
 */
export function cropStyle(crop: PhotoCrop | null | undefined): CSSProperties {
  if (!crop || isDefaultCrop(crop)) return {};
  return {
    objectPosition: `${crop.x}% ${crop.y}%`,
    transformOrigin: `${crop.x}% ${crop.y}%`,
    transform: crop.scale === 1 ? undefined : `scale(${crop.scale})`,
  };
}
